$(document).ready(function () {
    $('.locations-2025-filters-heading-clear, .locations-2025-filters-mobile-button-clear-all').on('click', function (e) {
        e.preventDefault();
        clearLocationFilters();

        // Optional auto-submit:
        // $(this).closest('form').submit();
    });
});

// Reusable function
function clearLocationFilters() {
    // Clear "Open Now"
    $('#locations-2025-filters-status-open').prop('checked', false);

    // Clear "ER"
    $('#locations-2025-filters-status-er').prop('checked', false);

    // Clear "BMG"
    $('#locations-2025-filters-status-bmg').prop('checked', false);

    // Clear all Location-Type checkboxes
    $('.locations-2025-filters-location-type-checkbox').prop('checked', false);
}

$(document).on("click", "[data-toggle-class-element]", function () {
    var $trigger = $(this);

    var targetSelector = $trigger.attr("data-toggle-class-element");
    var toggleClass = $trigger.attr("data-toggle-class-name");

    var $target = $(targetSelector);
    if ($target.length === 0) return;

    var isOpen = $target.hasClass(toggleClass);

    if (isOpen) {
        $target.removeClass(toggleClass);
        $trigger.removeClass(toggleClass);
    } else {
        $target.addClass(toggleClass);
        $trigger.addClass(toggleClass);
    }
});

$(document).on("click", "[data-toggle-text]", function () {
    var $trigger = $(this);
    var toggledText = $trigger.attr("data-toggle-text");
    var targetSelector = $trigger.attr("data-toggle-text-target");

    var $targetElement = null;
    var textNode = null;

    // CASE 1: Target selector provided
    if (targetSelector) {
        $targetElement = $(targetSelector);

        if ($targetElement.length === 0) {
            console.warn("data-toggle-text-target selector not found:", targetSelector);
            return;
        }

        // Save default text once
        if (!$trigger.attr("data-toggle-text-default")) {
            $trigger.attr("data-toggle-text-default", $targetElement.text().trim());
        }

        var defaultText = $trigger.attr("data-toggle-text-default");
        var isToggled = $trigger.hasClass("text-toggled");

        if (isToggled) {
            $targetElement.text(defaultText);
            $trigger.removeClass("text-toggled");
        } else {
            $targetElement.text(toggledText);
            $trigger.addClass("text-toggled");
        }

    } else {
        // CASE 2: No selector ? modify first text node (fallback)

        var el = this;
        for (var i = 0; i < el.childNodes.length; i++) {
            if (el.childNodes[i].nodeType === Node.TEXT_NODE) {
                textNode = el.childNodes[i];
                break;
            }
        }

        if (!textNode) {
            console.warn("No text node found on element using fallback text toggle.");
            return;
        }

        // Save default original text once
        if (!$trigger.attr("data-toggle-text-default")) {
            $trigger.attr("data-toggle-text-default", textNode.nodeValue.trim());
        }

        var defaultText = $trigger.attr("data-toggle-text-default");
        var isToggled = $trigger.hasClass("text-toggled");

        if (isToggled) {
            textNode.nodeValue = defaultText;
            $trigger.removeClass("text-toggled");
        } else {
            textNode.nodeValue = toggledText;
            $trigger.addClass("text-toggled");
        }
    }
});

// Show chip when user clicks the geolocation button
$(".locations-2025-hero-tools-search-use-location-button").on("click", function () {
    $("#current-location-chip-2025").show();
});

// Clear input & hide chip
$(document).on("click", "#current-location-chip-2025", function () {

    //clear the value
    /*    const $input = $("#locations-2025-desktop-search-location");
        $input.val("");
        $input.attr("placeholder", $input.data("original-placeholder"));*/

    //hide the chip
    $(this).hide();
});

function updateFilterCount() {
    // Count all checked checkboxes inside the filter region
    var count = $("#locations-2025-filters-collapse input[type='checkbox']:checked").length;

    var $countSpan = $(".locations-2025-filters-toggle-button-count");

    if (count > 0) {
        $countSpan.text("(" + count + ")");
    } else {
        $countSpan.text("");
    }
}

// Any checkbox change updates the count
$(document).on("change", "#locations-2025-filters-collapse input[type='checkbox']", function () {
    updateFilterCount();
});

$(document).ready(function () {
    updateFilterCount();
    updateActiveFilterChips();
});

function updateActiveFilterChips() {
    var $chipContainer = $(".locations-2025-active-filter-chips-container");
    var $chipList = $(".locations-2025-active-filter-chips");
    var $chipTemplate = $chipList.find("[data-template]");

    // Find all checked checkboxes inside the filter area
    var $checked = $(".locations-2025-filters-collapse input[type='checkbox']:checked");

    if ($checked.length === 0) {
        // No active filters ? keep container hidden
        return;
    }

    // Show the chip container
    $chipContainer.addClass("active-chips");

    // Build chips
    $checked.each(function () {
        var $cb = $(this);
        var labelText = "";

        // Find label associated with this checkbox
        var id = $cb.attr("id");
        var $label = $("label[for='" + id + "']");
        if ($label.length) {
            labelText = $.trim($label.text());
        } else {
            // fallback to checkbox value
            labelText = $cb.val();
        }

        // Clone template
        var $chip = $chipTemplate.clone(false);
        $chip.removeAttr("data-template");

        // Insert label text
        $chip.append(document.createTextNode(labelText));

        // Add checkbox reference
        $chip.attr("data-filter-id", id);

        // Add to DOM
        $chipList.append($chip);
    });
}

// Clicking a chip ? uncheck the associated filter ? trigger change ? form submits
$(document).on("click", ".locations-2025-active-filter-chip:not([data-template])", function () {

    var checkboxId = $(this).attr("data-filter-id");
    var $checkbox = $("#" + checkboxId);

    if ($checkbox.length) {
        $checkbox.prop("checked", false).trigger("change");
    }
});
